export default __webpack_public_path__ + "static/media/newsletter.5b37ae12.svg";